import { ComponentProps } from "react";
import { useTenantTranslation } from "hooks/formatters";
import { ParameterConflict } from "src/store/api/generatedApi";
import { MarkerDot } from "./MarkerDot";
import { conflictAppearance } from "./parameterConflicts";

export const ConflictMarkerDot = ({
  conflicts,
  ...props
}: Omit<ComponentProps<typeof MarkerDot>, "color" | "label"> & {
  conflicts: ParameterConflict[];
}) => {
  const { t } = useTenantTranslation();
  const appearance = conflictAppearance(conflicts);
  return conflicts.length > 0 ? (
    <MarkerDot
      {...props}
      color={appearance.colour}
      label={t(appearance.label)}
    />
  ) : null;
};
